var map = {
	"./en.json": 837,
	"./en_ID.json": 785,
	"./en_MM.json": 786,
	"./en_MY.json": 787,
	"./en_PH.json": 788,
	"./en_SG.json": 789,
	"./en_TH.json": 790,
	"./en_VN.json": 791,
	"./fr.json": 2582,
	"./fr_MA.json": 1249,
	"./id.json": 2583,
	"./id_ID.json": 1250,
	"./my.json": 2584,
	"./th.json": 2585,
	"./th_TH.json": 1251,
	"./vi.json": 2586,
	"./vi_VN.json": 1252,
	"./zh.json": 2587,
	"./zh_CN.json": 1253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2581;